module.exports = __webpack_public_path__ + "img/pay-value8.862b17d2.png";